var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 48,
    viewBox: "0 -960 960 960",
    width: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M278.309-140.001q-23.596 0-40.644-17.048-17.048-17.049-17.048-40.645v-544.228h-40.616v-45.384h171.076v-28.077h257.846v28.077h171.076v45.384h-40.616v544.228q0 23.529-17.081 40.611-17.082 17.082-40.611 17.082H278.309ZM694-741.922H266v544.228q0 5.385 3.654 8.847 3.655 3.462 8.655 3.462h403.382q4.616 0 8.462-3.846 3.847-3.847 3.847-8.463v-544.228ZM381.232-269.846h45.383v-388.615h-45.383v388.615Zm152.153 0h45.383v-388.615h-45.383v388.615ZM266-741.922V-185.385-741.922Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.9428c2a3f9c987265447dbbaa22c7c6f.svg";
export { ForwardRef as ReactComponent };